(function () {
    'use strict';

    angular
        .module('app.service')
        .factory('userService', userservice);

    /* @ngInject */
    function userservice(coreService, config, $odataresource, moment) {
        var service = {
            getDefaultUser: getDefaultUser,
            getModalOptions: getModalOptions,
            getUserSearchField: getUserSearchField,
            getAdministratorSearchField: getAdministratorSearchField,
            getUsers: getUsers,
            getUser: getUser,
            getConnectionTypes: getConnectionTypes,
            searchEmail: searchEmail,
            EmailExistsOrIsDomainAccount: EmailExistsOrIsDomainAccount,
            setActive: setActive,
            resetUserPassword: resetUserPassword,
            searchADUser: searchADUser,
            searchUsersNotAssignedToApplication: searchUsersNotAssignedToApplication,
            getODataResource: getODataResource,
            getTableConfig: getTableConfig,
            dropDownApplicationTypes: dropDownApplicationTypes,
            getUserByCustomerId: getUserByCustomerId,
            bulkMoveUsers: bulkMoveUsers
        };

        activate();

        return service;

        function activate() {
        }

        function getODataResource() {
            return $odataresource(config.apiUrl + 'odata/Users',
                {},
                {},
                {
                    odatakey: 'UserID',
                    isodatav4: true
                });
        }

        function getDefaultUser() {
            var user = {
                UserId: 0,
                Auth0UserId: '',
                Email: '',
                IsActive: true,
                FullName: '',
                CreatedUserId: 0,
                DateCreated: moment().toDate(),
                UpdatedUserId: 0,
                DateUpdated: moment().toDate(),
                Deleted: false
            };
            return user;
        }

        function getTableConfig() {
            return {
                columns: [
                    {
                        id: 'ConnectionTypeId',
                        displayName: 'Connection Type',
                        ODataKey: 'ConnectionTypeId',
                        type: 'dropDown',
                        DropDown: { parent: 'ConnectionType', key: 'ConnectionName' },
                        options: dropDownApplicationTypes()
                    },
                    {
                        id: 'Email',
                        displayName: 'Email',
                        ODataKey: 'Email',
                        type: 'match',
                        tooltip: {
                            placement: 'right',
                            text: function (row) {
                                var applications = {};
                                angular.forEach(row.UserRoleTies, function (userRole) {
                                    applications[userRole.Role.Application.ApplicationName] =
                                        (applications[userRole.Role.Application.ApplicationName] || '') +
                                        ', ' + userRole.Role.RoleName;
                                });
                                var tooltip = '';
                                angular.forEach(applications, function (value, key) {
                                    value = value.slice(2);
                                    tooltip = tooltip + key + ': ' + value + '\n';
                                });
                                return tooltip;
                            }
                        }
                    },
                    {
                         id: 'FullName',
                         displayName: 'Full Name',
                         ODataKey: 'FullName',
                         type: 'match'
                    },
                    {
                        id: 'InviteEmailSent',
                        displayName: 'Invite Email',
                        ODataKey: 'InviteEmailSent',
                        type: 'badge',
                        badge: {
                            on: {
                                className: 'success',
                                display: 'Sent'
                            },
                            off: {
                                className: 'danger',
                                display: 'Not Sent'
                            }
                        }
                    },
                    {
                         id: 'IsActive',
                         displayName: 'Is Active',
                         ODataKey: 'IsActive',
                         type: 'match',
                         badge: {
                             on: {
                                 className: 'success',
                                 display: 'Active'
                             },
                             off: {
                                 className: 'danger',
                                 display: 'Inactive'
                             }
                         }
                    },
                    {
                        id: 'UserType',
                        displayName: 'User Type',
                        ODataKey: 'UserType/UserTypeName',
                        type: 'subItem'
                    },
                    {
                        id: 'CustomerSiteId',
                        displayName: 'Customer ID',
                        ODataKey: 'UserSettings/CustomerSiteId',
                        type: 'subItem'
                    }
                ],
                actions: []
            };
        }

        function getUserSearchField(applicationID, userAddClick) {
            var userFields = [{
                key: 'user',
                type: 'typeahead-async',
                defaultValue: { Email: '' },
                className: 'form-group typeahead-email',
                templateOptions: {
                    type: 'Email',
                    label: 'Add User to application',
                    placeholder: 'Search Email Address',
                    required: true,
                    style: { 'min-width': '350px' },
                    options: function (email) {
                        return searchUsersNotAssignedToApplication(applicationID, email)
                            .then(function (response) {
                                if (response.status === 200) {
                                    return response.data;
                                }
                                return [];
                            });
                    },

                    display: 'Email'
                }
            },
            {
                type: 'button',
                className: 'form-group',
                templateOptions: {
                    text: 'Add User',
                    onClick: userAddClick
                }
            }];
            return userFields;
        }

        function getAdministratorSearchField(applicationID, administratorAddClick) {
            var userFields = [{
                key: 'user',
                type: 'typeahead-async',
                defaultValue: { Email: '' },
                className: 'form-group',
                templateOptions: {
                    type: 'Email',
                    label: 'Add Administrator to application',
                    placeholder: 'Search Email Address',
                    style: { 'min-width': '350px' },
                    required: true,
                    options: function (email) {
                        return searchAdministratorNotAssignedToApplication(applicationID, email)
                            .then(function (response) {
                                if (response.status === 200) {
                                    return response.data;
                                }
                                return [];
                            });
                    },

                    display: 'Email'
                }
            },
            {
                type: 'button',
                className: 'form-group',
                templateOptions: {
                    text: 'Add Administrator',
                    onClick: administratorAddClick
                }
            }];
            return userFields;
        }

        function getUsers(tableState) {
            var user = getODataResource();
            var query = user.odata();

            if (!!tableState) {
                coreService.processODataFilters(query, tableState.search.predicateObject, getTableConfig().columns);
                coreService.processODataPage(query, tableState.pagination);
            } else {
                tableState = { sort: {} };
            }
            tableState.sort = tableState.sort.predicate ? tableState.sort : { predicate: 'Email', reverse: false };
            coreService.processODataSort(query, tableState.sort);

            return query
                .expand('ConnectionType')
                .expand('UserApplicationTies')
                .expand('UserApplicationTies', 'Application')
                .expand('UserRoleTies')
                .expand('UserRoleTies', 'Role')
                .expand('UserRoleTies', 'Role', 'Application')
                .expand('UserType')
                .expand('UserSettings')
                .withInlineCount()
                .query()
                .$promise.then(function (results) {
                    angular.forEach(results, function (user) {
                        if (user.UserTypeId === null || user.UserType === null) {
                            user.UserType = {
                                UserTypeId: null,
                                UserTypeName: 'N/A'
                            };
                        }
                        if (user.UserSettings === null) {
                            user.UserSettings = {
                                CustomerSiteId: 0
                            };
                        }
                        if (user.UserSettings.CustomerSiteId === null) {
                            user.UserSettings.CustomerSiteId = 0;
                        }
                    });
                    return results;
                });
        }

        function getUser(userID) {
            var user = getODataResource();
            var query = user.odata();

            return query
                .expand('ConnectionType')
                .expand('Profile')
                .expand('UserRoleTies', 'Role')
                .expand('UserRoleTies', 'Role', 'Application')
                .expand('UserSettings')
                .expand('UserSettings', 'Site')
                .expand('UserSettings', 'Site', 'Country')
                .expand('UserSettings', 'Site', 'State')
                .expand('UserSettings', 'TraffilogViewCustomer')
                .expand('UserSiteTies')
                .expand('UserSiteTies', 'Site')
                .expand('UserTruckTies')
                .expand('UserTruckTies', 'Truck')
                .expand('UserType')
                .get(userID)
                .$promise;
        }

        function getConnectionTypes() {
            return [
                {
                    ConnectionTypeId: 1,
                    ConnectionName: 'Active Directory'
                },
                {
                    ConnectionTypeId: 2,
                    ConnectionName: 'External User'
                }
            ];
        }

        function searchEmail(Email) {
            var url = coreService.updateQueryStringParameter('user/EmailExists', 'Email', Email);
            return coreService.httpAccountsGet(url, true);
        }

        function EmailExistsOrIsDomainAccount(Email) {
            var url = coreService.updateQueryStringParameter('user/EmailExistsOrIsDomainAccount', 'Email', Email);
            return coreService.httpAccountsGet(url, true);
        }

        function searchADUser(Email) {
            var url = coreService.updateQueryStringParameter('user/ActiveDirectorySearch', 'Email', Email);
            return coreService.httpAccountsGet(url, true);
        }

        function getModalOptions() {
            return {
                animation: true,
                templateUrl: 'app/user/dashboard/modal/user.modal.html',
                controllerAs: 'vm'
            };
        }

        function setActive(user) {
            var data = {
                IsActive: user.IsActive
            };
            var url = 'user/';
            url = url + encodeURIComponent(user.UserId);
            url = url + '/SetActive';
            return coreService.httpAccountsPost(url, data);
        }

        function resetUserPassword(user) {
            var data = {
                IsActive: user.IsActive
            };
            var url = 'user/';
            url = url + encodeURIComponent(user.UserId);
            url = url + '/forgotPassword';
            return coreService.httpAccountsPost(url, data);
        }

        function dropDownApplicationTypes() {
            return getConnectionTypes().map(function (connectionType) {
                return {
                    value: connectionType.ConnectionTypeId,
                    name: connectionType.ConnectionName
                };
            });
        }

        function searchUsersNotAssignedToApplication(applicationId, Email) {
            var url = coreService.updateQueryStringParameter(
                'user/application/' + applicationId + '/notAssignedSearch',
                'Email', Email);
            return coreService.httpAccountsGet(url, Email);
        }

        function searchAdministratorNotAssignedToApplication(applicationId, Email) {
            var url = coreService.updateQueryStringParameter(
                'admin/application/' + applicationId + '/notAssignedSearch',
                'Email', Email);
            return coreService.httpAccountsGet(url, Email);
        }

        function getUserByCustomerId(customerId) {
            var url = 'user/';
            url = url + encodeURIComponent(customerId);
            url = url + '/getUsersByCustomerId';
            return coreService.httpAccountsGet(url);
        }

        function bulkMoveUsers(customerId, data) {
            var url = 'user/';
            url = url + encodeURIComponent(customerId);
            url = url + '/bulkMoveUsers';
            return coreService.httpAccountsPost(url, data);
        }
    }
})();
